import type { DefaultTheme } from 'styled-components';
import { colors } from '../../style';
import { actionColor } from '../../style/theme-helpers';

export const variants: Record<string, string | ((props: { theme: DefaultTheme }) => string)> = {
  gray100: colors.gray100,
  gray300: colors.gray300,
  gray400: colors.gray400,
  gray600: colors.gray600,
  action: actionColor,
  white: colors.white,
  black: colors.black,
};
